import React, {useRef, useState, useEffect } from 'react';
import {Row, Col, Card, Button, Form, Spinner, Table, Dropdown, Modal} from 'react-bootstrap';
import {list, add, remove} from '../../../lib/api/competitionClubs';
import {_exportPDF} from "../../../lib/api/api";
import classNames from "classnames";
import Flex from "../../common/Flex";
import CardDropdown from "../../common/CardDropdown";
import {Add} from "./AddClubs";
import Avatar from "../../common/Avatar";
import { toast } from 'react-toastify';

export function List({ initialData, onClose, onSave }) {
  console.log('initialData',initialData)
  const [competition, setCompetition] = useState(initialData);
  const [clubs, setClubs] = useState([]);
  const [selectedCompetition, setSelectedCompetition] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

    const getClubsList = async () => {
        const resClubs = await list(competition.competitions_guid);
        console.log('resClubs',resClubs)
        setClubs(resClubs);
    }
  useEffect(() => {
    (async () => {
      console.log('competition.competitions_guid',competition.competitions_guid)
        await getClubsList();
    })();
  }, [competition]);

    const handleAdd = () => {
        setSelectedCompetition(competition);
        setShowModal(true);
    };

    const handelDelete = async (id, name) => {
        if (confirm(`Da li ste sigurni da želite da izbrišete klub ${name}?`)) {
            try {
                await remove(id);
                setClubs((prev) => prev.filter((p) => p.competitions_club_guid !== id));
            } catch (error) {
                toast.error(error.body?.message || error.message || 'Brisanje kluba nije uspjelo.');
            }
        }
    };

    const playersToPdf = async (club_guid) => {
        return await _exportPDF(`report/pdf/${club_guid}`);
    };

    const stafToPdf = async (club_guid) => {
        return await _exportPDF(`report/pdf-staff/${club_guid}`);
    };

    const registrationToPdf = async (club_guid) => {
        return await _exportPDF(`report/pdf-registration/${club_guid}`);
    };

    const renderActions = item => (
        <CardDropdown>
            <div className="py-2">
                <Dropdown.Item onClick={() => handelDelete(item.competitions_club_guid, item.clubs_name)}>Izbriši</Dropdown.Item>
                <Dropdown.Divider/>
                <Dropdown.Item onClick={() => playersToPdf(item.club_guid)}>Štampaj licence igrači</Dropdown.Item>
                <Dropdown.Item onClick={() => stafToPdf(item.club_guid)}>Štampaj licence treneri</Dropdown.Item>
                <Dropdown.Item onClick={() => registrationToPdf(item.club_guid)}>Štampaj preregistracija kluba i igrača</Dropdown.Item>
            </div>
        </CardDropdown>
    );

    return (
      <Card className={classNames('h-100')}>
        <Card.Header>
          <Row className={classNames('g-2')}>
            <Col>
              <Flex>
                <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                  Spisak klubova
                </h5>
              </Flex>
            </Col>
            <Col xs="auto">
              <Button onClick={handleAdd} variant="primary">
                Dodaj klub
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body className="bg-body-tertiary">
          {isLoading ? (
              <div className="text-center">
                <Spinner animation="border" role="status" />
              </div>
          ) : (
              <Row className="mb-3">
                <div className="d-none d-xl-block">
                  <Table responsive>
                    <thead>
                    <tr>
                      <th scope="col">Klub</th>
                      <th className="text-end" scope="col">Akcija</th>
                    </tr>
                    </thead>
                    <tbody>
                    {clubs.map((item, i) => (
                        <tr key={i}>
                            <td className="text-nowrap">
                                <div className="d-flex align-items-center">
                                    <Avatar src={process.env.REACT_APP_BASE_API_URL + `/uploads/${item.image_path}`} size="xl" name={item.name} />
                                    <div className="ms-2">{item.clubs_name}</div>
                                </div>
                            </td>
                          <td className="text-end">{renderActions(item)}</td>
                        </tr>
                    ))}
                    </tbody>
                  </Table>
                </div>

                <div className="d-xl-none">
                  <Row className="g-3">
                    {clubs.map((item, i) => (
                      <Col xs={12} key={item.competitions_club_guid || i}>
                        <div
                          className="border rounded-4 bg-white h-100 p-3 shadow-sm"
                          style={{ borderColor: '#dfe3ee' }}
                        >
                          <div className="d-flex align-items-start justify-content-between gap-3">
                            <div className="flex-shrink-0">
                              <Avatar
                                src={process.env.REACT_APP_BASE_API_URL + `/uploads/${item.image_path}`}
                                size="2xl"
                                name={item.clubs_name}
                              />
                            </div>
                            <div className="flex-shrink-0">{renderActions(item)}</div>
                          </div>

                          <div className="mt-3">
                            <div className="fw-semibold text-dark fs-8">{item.clubs_name || '-'}</div>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Row>
          )}
        </Card.Body>

        <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Dodaj klubove</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedCompetition ? (
                <Add
                    initialData={selectedCompetition}
                    onClose={() => setShowModal(false)}
                    onSave={getClubsList}
                />
            ) : null}
          </Modal.Body>
        </Modal>
      </Card>
  );
}
